export default {
    info: {
        method: 'GET',
        url: '/user/:uid/recent/{time}',
        name: '获取用户信息',
    },
    warehouseList: {
        method: 'POST',
        url: '/admin/warehouse/list',
        name: '仓库管理列表',
    },
    tradeDetail: {
        method: 'POST',
        url: '/admin/warehouse/list/{uid}',
        name: '商品仓库仓储',
    },
    delectStorage: {
        method: 'DELETE',
        url: '/admin/warehouse/{id}',
        name: '删除仓库仓储',
    },
    addStorage: {
        method: 'POST',
        url: '/admin/warehouse/add',
        name: '添加仓库仓储',
    },
    updateStorage: {
        method: 'PUT',
        url: '/admin/warehouse/update',
        name: '修改仓库仓储',
    },
    getTypeList: {
        method: 'GET',
        url: '/admin/warehouse/getTypeList',
        name: '仓库列表',
    },
    getPrincipal: {
        method: 'GET',
        url: '/admin/warehouse/getPrincipal/{shopId}',
        name: '仓库负责人列表',
    },
    getRetailList: {
        method: 'POST',
        url: '/admin/retail/list',
        name: '零售仓储管理列表',
    },
    productDetail: {
        method: 'GET',
        url: '/admin/retail/{id}',
        name: '商品详情',
    },
    stockRemovalList: {
        method: 'POST',
        url: '/admin/retail/stockRemovalList',
        name: '商品出库记录',
    },
    stockInList: {
        method: 'POST',
        url: '/admin/retail/stockInList',
        name: '商品入库记录',
    },
    updateRetail: {
        method: 'PUT',
        url: '/admin/retail/update',
        name: '编辑商品',
    },
    goodsCateList: {
        method: 'GET',
        url: '/admin/retail/goodsCateList',
        name: '商品类别',
    },
    goodsUnitList: {
        method: 'GET',
        url: '/admin/retail/goodsUnitList',
        name: '商品单位类别',
    },
    isExistsType: {
        method: 'GET',
        url: '/admin/retail/isExists/{type}',
        name: '判断类别',
    },
    goodsPut: {
        method: 'POST',
        url: '/admin/retail/goodsPut',
        name: '商品入库',
    },
    goodsOut: {
        method: 'POST',
        url: '/admin/retail/goodsOut',
        name: '申请出库',
    },
    inventoryChanges: {
        method: 'PUT',
        url: '/admin/retail/inventoryChanges',
        name: '库存盘点-修改录入',
    },
    checkLogList: {
        method: 'POST',
        url: '/admin/retail/checkLogList',
        name: '库存盘点',
    },
    affirm: {
        method: 'POST',
        url: '/admin/retail/affirm',
        name: '库存确认',
    },
    inventoryList: {
        method: 'POST',
        url: '/admin/retail/inventoryList',
        name: '库存盘点',
    },
    comfirmRole: {
        method: 'GET',
        url: '/admin/retail/sysRole/{shopId}',
        name: '审核人职位',
    },
    comfirmMember: {
        method: 'GET',
        url: '/admin/retail/sysUser/{shopId}',
        name: '审核人',
    },
    transfers: {
        method: 'POST',
        url: '/admin/retail/transfers',
        name: '审核',
    },
    getWarehouseList: {
        method: 'GET',
        url: '/admin/warehouse/getWarehouseList/{shopId}',
        name: '仓库名称列表',
    },
    goodsList: {
        method: 'GET',
        url: '/admin/retail/goodsList',
        name: '商品列表',
    },
    warehouseInventory: {
        method: 'GET',
        url: '/admin/retail/warehouseInventory/{warehouseId}',
        name: '库存盘点',
    },
    warehouseInventoryPost: {
        method: 'POST',
        url: '/admin/retail/warehouseInventory',
        name: '库存盘点',
    },
    delInventoryLog: {
        method: 'DELETE',
        url: '/admin/retail/delInventoryLog/{id}',
        name: '删除库存盘点记录',
    },
    checkLogList: {
        method: 'POST',
        url: '/admin/retail/checkLogList',
        name: '库存盘点详情',
    },
    wareGoodsList: {
        method: 'GET',
        url: '/admin/retail/goodsList/{warehouseId}/{useType}',
        name: '返回当前仓库的商品信息列表',
    },
    addGoodsUnit: {
        method: 'POST',
        url: '/admin/retail/addGoodsUnit',
        name: '新增商品单位',
    },
    isNumExist: {
        method: 'POST',
        url: '/admin/warehouse/isNumExist',
        name: '检查仓库编号是否存在 存在返回true 否false',
    },
    isWarehouseNameExist: {
        method: 'POST',
        url: '/admin/warehouse/isWarehouseNameExist',
        name: '检查仓库名称是否存在 存在返回true 否false',
    },
    addStockNum: {
        method: 'POST',
        url: '/admin/retail/addStockNum',
        name: '添加库存',
    },
    storageSave: {
        method: 'POST',
        url: '/admin/warehouse/list/storage',
        name: '仓库管理-仓库存储列表',
    },
    isNumExistGoods: {
        method: 'POST',
        url: '/admin/retail/isNumExist',
        name: '检查商品编号是否存在 存在返回true 否false',
    },
    isNameExist: {
        method: 'POST',
        url: '/admin/retail/isNameExist',
        name: '检查商品名称是否存在 存在返回true 否false',
    },
    SearchWareGoodsList: {
        method: 'POST',
        url: '/admin/retail/goodsList/management',
        name: '商品名称模糊查询当前仓库的商品信息列表',
    },
    exportStorage: {
        method: 'POST',
        url: '/admin/warehouse/warehouse/export',
        name: '仓库仓储导出',
    }
}